document.addEventListener('DOMContentLoaded', function () {
  // Standaard incl. BTW tonen; bezoeker kan via de toggle naar excl. wisselen
  if (sessionStorage.getItem('pricesIncludeVat') == null) {
    sessionStorage.setItem('pricesIncludeVat', 'true');
  }

  const includeVAT = sessionStorage.getItem('pricesIncludeVat') === 'true';
  calculatePrices(includeVAT);
  updateTextToVat(includeVAT);

  const toggles = document.querySelectorAll('.vat-switcher-toggle');
  toggles.forEach((toggle) => {
    updateToggleVisuals(toggle, includeVAT);
    toggle.addEventListener('click', () => toggleTaxPrices(toggle));
  });

  // Na staffel-refresh (quantity/variant) alleen staffel-prijzen opnieuw met juiste BTW-weergave (hoofdprijs blijft van variant-picker)
  document.addEventListener('volume-discounts-refreshed', function () {
    const includeVAT = sessionStorage.getItem('pricesIncludeVat') === 'true';
    applyVatToStaffelPrices(includeVAT);
  });
});

/** Alleen prijzen in #volume-discount-container (staffel) incl/excl BTW zetten */
function applyVatToStaffelPrices(includeVAT) {
  const container = document.querySelector('#volume-discount-container');
  if (!container) return;
  const vatPercentage = 21;
  container.querySelectorAll('[data-excl-price]').forEach(function (priceElement) {
    const exclPrice = parseFloat(priceElement.dataset.exclPrice);
    if (isNaN(exclPrice)) return;
    const displayPrice = includeVAT ? exclPrice * (1 + vatPercentage / 100) : exclPrice;
    const formattedPrice = (displayPrice / 100).toFixed(2).replace('.', ',');
    var prefix = '';
    var cur = (priceElement.textContent || '').trim();
    if (cur.indexOf('-') === 0) prefix = '-€';
    else if (cur.indexOf('€') === 0) prefix = '€';
    else prefix = '€';
    priceElement.innerHTML = prefix + formattedPrice;
  });
}

/** Globaal: BTW-weergave opnieuw toepassen (bv. na dynamische prijsupdates) */
window.reapplyVatPrices = function () {
  const includeVAT = sessionStorage.getItem('pricesIncludeVat') === 'true';
  calculatePrices(includeVAT);
};

function toggleTaxPrices(toggle) {
  const pricesIncludeVat = sessionStorage.getItem('pricesIncludeVat');

  if (pricesIncludeVat == null) {
    sessionStorage.setItem('pricesIncludeVat', 'false');
  } else {
    if (pricesIncludeVat === 'false') {
      sessionStorage.setItem('pricesIncludeVat', 'true');
      document.querySelectorAll('.vat-switcher-title').forEach((title) => {
        title.innerHTML = `Incl. BTW`;
      });
      document.querySelectorAll('.vat-switcher-toggle').forEach((t) => updateToggleVisuals(t, true));
      calculatePrices(true); // Switch to including VAT prices
      updateTextToVat(true);
    } else {
      sessionStorage.setItem('pricesIncludeVat', 'false');
      document.querySelectorAll('.vat-switcher-title').forEach((title) => {
        title.innerHTML = `Excl. BTW`;
      });
      document.querySelectorAll('.vat-switcher-toggle').forEach((t) => updateToggleVisuals(t, false));
      calculatePrices(false); // Switch to excluding VAT prices
      updateTextToVat(false);
    }
  }
}

function calculatePrices(includeVAT) {
  const prices = document.querySelectorAll('[data-excl-price]');
  const oppositePrices = document.querySelectorAll('[data-incl-price]'); // laat staan als je dit gebruikt

  prices.forEach((priceElement) => {
    const exclPrice = parseFloat(priceElement.dataset.exclPrice);
    const vatPercentage = 21;
    const isConfiguratorPrice = priceElement.dataset.configuratorPrice === 'true';

    if (isNaN(exclPrice)) {
      console.error('Invalid price found on element:', priceElement);
      return;
    }

    const inclPrice = exclPrice * (1 + vatPercentage / 100);
    const displayPrice = includeVAT ? inclPrice : exclPrice;
    const formattedPrice = `€${(displayPrice / 100).toFixed(2).replace('.', ',')}`;

    if (isConfiguratorPrice) {
      // behoud + / - / Gratis
      const currentText = priceElement.textContent.trim();
      const hasPlusSign = currentText.startsWith('+');
      const hasMinusSign = currentText.startsWith('-');
      const hasGratis = currentText === 'Gratis';

      if (hasGratis) {
        priceElement.innerHTML = 'Gratis';
      } else if (hasPlusSign) {
        priceElement.innerHTML = `+ ${formattedPrice}`;
      } else if (hasMinusSign) {
        priceElement.innerHTML = `- ${formattedPrice}`;
      } else {
        // default: aannemen dat het positief is
        priceElement.innerHTML = `+ ${formattedPrice}`;
      }
    } else {
      // bestaand gedrag
      priceElement.innerHTML = formattedPrice;
    }
  });

  if (includeVAT) {
    document.querySelectorAll('[data-show-excl-price]').forEach((priceElement) => {
      const exclPrice = parseFloat(priceElement.dataset.exclPrice);
      priceElement.style.display = 'block';
      priceElement.innerHTML = `
        <span class="text-[#DDD9D9] text-xs font-normal">
          €${(exclPrice / 100).toFixed(2).replace('.', ',')}
        </span>
        <span class="text-[#DDD9D9] text-xs font-normal">(excl. btw)</span>`;
    });
  } else {
    document.querySelectorAll('[data-show-excl-price]').forEach((priceElement) => {
      const exclPrice = parseFloat(priceElement.dataset.exclPrice);
      priceElement.style.display = 'none';
      priceElement.innerHTML = `€${(exclPrice / 100).toFixed(2).replace('.', ',')}`;
    });
  }
}

function updateTextToVat(includeVAT) {
  const texts = document.querySelectorAll('*:not(script):not(style)');
  texts.forEach((element) => {
    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent;
        if (includeVAT) {
          text = text
            .replace(/excl\. BTW/g, 'incl. BTW')
            .replace(/excl\. btw/g, 'incl. btw')
            .replace(/Excl\. BTW/g, 'Incl. BTW');
          node.textContent = text;
        } else {
          text = text
            .replace(/incl\. BTW/g, 'excl. BTW')
            .replace(/incl\. btw/g, 'excl. btw')
            .replace(/Incl\. BTW/g, 'Excl. BTW');
          node.textContent = text;
        }
      }
    });
  });
}

function updateToggleVisuals(toggle, includeVAT) {
  if (!toggle) return;

  if (includeVAT) {
    document.querySelectorAll('.vat-switcher-title').forEach((title) => {
      title.innerHTML = `Incl. BTW`;
    });
  } else {
    document.querySelectorAll('.vat-switcher-title').forEach((title) => {
      title.innerHTML = `Excl. BTW`;
    });
  }

  const togglers = toggle.querySelectorAll('.toggler');
  if (togglers) {
    togglers.forEach((toggle) => {
      toggle.classList.toggle('left-22', includeVAT);
      toggle.classList.toggle('left-2', !includeVAT);
    });
  }
}
